import React from 'react';
import '../styles/components/audit-label.css';

const AuditLabel = ({ 
    createdBy, 
    updatedBy, 
    createdAt, 
    updatedAt, 
    size = 'small',
    showBoth = false 
}) => {
    const formatDate = (dateString) => {
        if (!dateString) return '';
        
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';
            
            return date.toLocaleString('es-ES', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (error) {
            return '';
        }
    };

    const getDisplayInfo = () => {
        // If we have updatedBy and it's different from createdBy, show the updater
        if (updatedBy && updatedBy.username && createdBy && updatedBy._id !== createdBy._id) {
            return {
                action: 'Modified by',
                user: updatedBy.username,
                date: updatedAt
            };
        }
        
        // Otherwise show the creator
        if (createdBy && createdBy.username) {
            return {
                action: 'Created by',
                user: createdBy.username,
                date: createdAt
            };
        }
        
        return null;
    };

    const displayInfo = getDisplayInfo();
    
    if (!displayInfo) {
        return null;
    }

    const formattedDate = formatDate(displayInfo.date);

    return (
        <div className={`audit-label audit-label-${size}`}>
            {showBoth ? (
                <div className="audit-both">
                    {createdBy && createdBy.username && (
                        <div className="audit-item">
                            <span className="audit-action">Created by</span>
                            <span className="audit-user">{createdBy.username}</span>
                            {formattedDate && <span className="audit-date">{formatDate(createdAt)}</span>}
                        </div>
                    )}
                    {updatedBy && updatedBy.username && updatedBy._id !== createdBy?._id && (
                        <div className="audit-item">
                            <span className="audit-action">Modified by</span>
                            <span className="audit-user">{updatedBy.username}</span>
                            {formattedDate && <span className="audit-date">{formatDate(updatedAt)}</span>}
                        </div>
                    )}
                </div>
            ) : (
                <div className="audit-single">
                    <span className="audit-action">{displayInfo.action}</span>
                    <span className="audit-user">{displayInfo.user}</span>
                    {formattedDate && <span className="audit-date">{formattedDate}</span>}
                </div>
            )}
        </div>
    );
};

export default AuditLabel;